import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ROUTES } from '../../core/router/routes';
import { CommonState } from './commonTypes';
import { Breadcrumbs } from '../model/commonModel';

const initialState: CommonState = {
  breadcrumbs: [
    {
      label: 'dashboard.home_page',
      to: ROUTES.DASHBOARD,
    },
  ],
  activeMenuItem: undefined,
  phrase: '',
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setPhrase: (state, action: PayloadAction<string>) => {
      state.phrase = action.payload;
    },
    setActiveMenuItem: (state, action: PayloadAction<number>) => {
      state.activeMenuItem = action.payload;
    },
    setBreadcrumbs: (state, action: PayloadAction<Breadcrumbs[]>) => {
      if (action.payload) {
        state.breadcrumbs = [...initialState.breadcrumbs, ...action.payload];
      } else {
        state.breadcrumbs = [...initialState.breadcrumbs];
      }
    },
    resetBreadcrumbs: (state) => {
      state.breadcrumbs = [];
    },
  },
});

export const { setPhrase, setActiveMenuItem, setBreadcrumbs } = commonSlice.actions;
